module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_001_sm-e6df4459.png";